<template>
  <a-drawer
    :visible="visible"
    title="修改计划单"
    :mask-closable="false"
    class="edit-plan-modal"
    ok-text="提交"
    width="960px"
    @close="onCancel()"
  >
    <a-alert
      class="alert-tip"
      message="发车时间3天以内的计划单修改，需经过审核并通过"
      type="warning"
      banner
      show-icon
    />
    <a-spin :spinning="spinning">
      <div :spinning="spinning" class="flex justify-between" style="height: calc(100% - 68px)">
        <div class="upload">
          <block-title title="选择文件" class="block margin" :show-line="false">
            <div class="item-content">
              <div class="content-upload">
                <a-upload :show-upload-list="false" :before-upload="beforeUpload">
                  <a-button class="uploadBtn" type="primary">
                    <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt />
                    {{ selectFileBtnTxt }}
                  </a-button>
                </a-upload>
              </div>
              <p class="tips">
                单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx/xls
              </p>
              <div v-if="file" class="batch-file">
                <div>
                  <a-icon type="file" />
                  {{ file.name }}
                </div>
                <img
                  class="filenameRight cursor"
                  src="@/assets/img/icon/icon_lajitong.png"
                  alt
                  @click="removeFile"
                />
              </div>
            </div>
          </block-title>
          <block-title v-if="!showAudit" title="变更原因" class="block" :show-line="false">
            <div>
              <a-input
                v-model="formData.reason"
                type="textarea"
                :rows="4"
                placeholder="请输入变更原因"
              />
            </div>
          </block-title>
          <block-title v-if="showAudit" title="审核流程" class="block" :show-line="false">
            <div>
              <p class="tips desc">
                <a-icon type="info-circle" />新增/编辑/删除3天以内的计划单，需经过邮件审核并通过
              </p>
              <div
                v-if="PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus] === '同意'"
                class="approved"
              >
                审批通过
              </div>
              <div
                v-if="PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus] !== '同意'"
                class="not-approved"
              >
                审批未通过 未通过原因：{{
                  PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus] === "驳回"
                    ? editRecord.planMsgApprove && editRecord.planMsgApprove.content
                      ? editRecord.planMsgApprove.content
                      : ""
                    : PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus]
                }}
              </div>
              <div style="margin-bottom: 12px;">
                <a-input
                  v-model="formData.reason"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入变更原因"
                />
              </div>
              <a-button
                v-if="!auditDisable"
                icon="mail"
                type="primary"
                :disabled="auditDisable"
                @click="sendAudit"
                >{{ auditDisable ? "审核邮件已发送" : "发送审核邮件" }}</a-button
              >
              <a-button
                v-else-if="PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus] === '驳回'"
                icon="mail"
                type="primary"
                @click="sendAudit"
                >{{ "重新发送" }}</a-button
              >
              <!-- <a-checkbox v-if="showConfirm" v-model="confirmAudit" class="confirm"
                                >确认已通过审核(勾选后可提交修改)</a-checkbox
                            > -->
            </div>
            <!-- 20221109新增上传复核后文件 wl -->
            <div v-if="auditDisable" class="item-content" style="margin-top: 12px;">
              <div class="content-upload">
                <a-upload :show-upload-list="false" :before-upload="beforeUploadReviewFile">
                  <a-button class="uploadBtn" type="primary">
                    <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt />
                    {{ reviewFile ? "重新选择" : "上传复核后文件" }}
                  </a-button>
                </a-upload>
              </div>
              <p class="tips">若审核后文件有调整，请通过左侧按钮上传，否则无需上传</p>
              <div v-if="reviewFile" class="batch-file">
                <div>
                  <a-icon type="file" />
                  {{ reviewFile.name }}
                </div>
                <img
                  class="filenameRight cursor"
                  src="@/assets/img/icon/icon_lajitong.png"
                  alt
                  @click="removeReviewFile"
                />
              </div>
            </div>
          </block-title>
        </div>
        <div class="history">
          <block-title title="历史版本" class="block margin list" :show-line="false">
            <a-timeline style="margin-left: 16px">
              <a-timeline-item v-for="(item, index) in historyList" :key="index">
                <div class="time-content">
                  <p>
                    <span class="version">{{ item.version }}</span>
                  </p>
                  <p>
                    操作人：
                    <span
                      >{{ item.createUser || item.operatorName }}({{
                        item.phone || item.operatorId
                      }})</span
                    >
                  </p>
                  <p>
                    操作时间：
                    <span>{{ item.createTime }}</span>
                  </p>
                  <p>
                    计划文件：
                    <a class="plan-name" :href="item.fileUrl">{{ item.fileName }}</a>
                  </p>
                  <p>
                    变更原因：
                    <span>{{ item.reason || "--" }}</span>
                  </p>
                </div>
              </a-timeline-item>
            </a-timeline>
          </block-title>
        </div>
      </div>
      <div class="drawer-bottom">
        <a-button @click="onCancel()">取消</a-button>
        <a-button
          :disabled="
            showAudit
              ? PLANSTATUSRESULTEMU[editRecord.msgPlanModifyApproveStatus] === '同意'
                ? false
                : true
              : false
          "
          type="primary"
          class="submit-btn"
          :loading="subloading"
          @click="onSubmit"
          >提交</a-button
        >
      </div>
    </a-spin>
    <a-modal
      title="邮件发送确认"
      :visible="emailConfirmVisible"
      :confirm-loading="emialConfirmLoading"
      :z-index="1001"
      @ok="handleSubmitSendEmail"
      @cancel="handelCancelEmailConfirm"
    >
      <div>
        <a-alert
          class="alert-tip"
          message="点击确认后，将发送邮件至下列收件人"
          type="warning"
          banner
          show-icon
        />
        <div style="margin-top: 12px;">
          <span> {{ remindEmailUsers }}</span>
        </div>
      </div>
    </a-modal>
  </a-drawer>
</template>

<script>
import BlockTitle from "@/components/panel/BlockTitle.vue";
import { getFileNameSuffix } from "@/utils/handleFile.js";
import https from "@/utils/http.js";
import * as moment from "moment";
import {
  getOperationLogs,
  getOperationLogsOld,
  planImport,
  updateTemp,
  sendApprovalEmail,
} from "../../api";
import { PLANSTATUSRESULTEMU } from "../const";
import { getAddresseeAndContentApi } from "../../../apis/email-manage";

export default {
  name: "EditPlan",
  components: {
    BlockTitle,
  },
  data() {
    return {
      PLANSTATUSRESULTEMU,
      visible: false,
      // 文件最大10M
      fileMaxSize: 1024 * 1024 * 10,
      // 文件类型暂时只支持 .xlsx
      fileTypeLimit: [".xlsx", ".xls"],
      editRecord: null,
      file: null,
      showAudit: false, // 显示审批流程
      auditDisable: false, // 禁用发送审批按钮
      showConfirm: false, // 显示勾选已通过审核
      confirmAudit: false, // 勾选已通过审核
      planEditHistory: null,
      historyList: [],
      spinning: false,
      reviewFile: null, // 复核文件
      emailConfirmVisible: false,
      emialConfirmLoading: false, // 发送邮件loading效果
      remindEmailUsers: '', // 需要提示的邮件用户列表
      innerThreeDays: false, // 发车时间3天以内的计划单
      approved: false,
      formData: {
        reason: "",
      },
      isDraft: false,
      subloading: false,
    };
  },
  computed: {
    selectFileBtnTxt() {
      return !this.file ? "选择文件" : "重新选择";
    },
  },
  methods: {
    async downFile(record) {
      await https({
        data: {
          planCode: record.planCode,
          planName: record.fileName,
          url: record.content,
        },
        url: "/plan_msg/export",
        service: "OTMS_WEB_PLUS_SERVER",
        name: `${record.fileName}排线`,
        type: "xlsx",
      });
    },
    async show(record, planEditHistory = {}) {
      if (record.isDraft) {
        this.isDraft = record.isDraft;
      }

      this.editRecord = record;
      this.planEditHistory = planEditHistory;
      if (planEditHistory[record.id]) {
        const {
          file,
          showAudit,
          auditDisable,
          showConfirm,
          confirmAudit,
          reason,
        } = planEditHistory[record.id];
        this.file = file;
        this.showAudit = showAudit;
        this.auditDisable = auditDisable;
        this.showConfirm = showConfirm;
        this.confirmAudit = confirmAudit;
        this.formData.reason = reason;
      }
      this.visible = true;
      const res = await getOperationLogs(record.planCode);
      if (res.length) {
        const list = [];
        res.forEach((item, i) => {
          list.push({
            ...item,
            version: `V${res.length - i}`,
            createTime: moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
            fileName: `V${res.length - i}_${moment(item.createTime).format("YYYYMMDD")}`,
          });
        });
        this.historyList = list;
      } else {
        const data = await getOperationLogsOld({
          bizNo: record.planCode,
          bizTypes: ["PLAN_MSG_LOG"],
        });
        const listData = [];
        data.forEach((item, i) => {
          listData.push({
            ...item,
            version: `V${data.length - i}`,
            createTime: moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
            fileName: `V${data.length - i}_${moment(item.createTime).format("YYYYMMDD")}`,
          });
        });
        this.historyList = listData;
      }
      if (this.showAudit) {
        this.formData.reason =
          this.editRecord.planMsgApprove && this.editRecord.planMsgApprove.reason
            ? this.editRecord.planMsgApprove.reason
            : "";
      }
    },
    removeFile() {
      this.file = null;
      this.showAudit = false;
      this.auditDisable = false;
      this.showConfirm = false;
      this.confirmAudit = false;
    },
    async beforeUpload(file) {
      this.file = file;
      this.showAudit = false;
      this.auditDisable = false;
      this.showConfirm = false;
      this.confirmAudit = false;
      await this.validateFile(file);
      return Promise.reject();
    },
    // 校验文件格式
    async validateFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);
      if (!fileTypeLimit.includes(fileType)) {
        this.file = null;
        this.$message.error("文件格式仅支持xlsx");
        return;
      }
      if (fileSize > fileMaxSize) {
        this.file = null;
        this.$message.error("文件最大不超过10M");
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("planCode", this.editRecord.planCode);
      formData.append("planMethod", this.editRecord.planMethod);
      this.spinning = true;
      try {
        const res = await planImport(formData);
        this.spinning = false;
        // 上传文件，根据返回显示审批
        this.showAudit = res.needCheck || false;
        this.file.url = res.fileUrl;
        this.auditDisable = false;
        this.showConfirm = false;
        this.confirmAudit = false;
      } catch (e) {
        this.spinning = false;
        this.file = null;
      }
    },
    async sendAudit() {
      try {
        const res = await getAddresseeAndContentApi({ mailCode: "UPDATE_APPROVE" });
        this.remindEmailUsers = res?.recipientAddressStr;
        this.emailConfirmVisible = true;
      } catch (err) {
        console.log(err);
      }
    },
    // 确认发送邮件
    async handleSubmitSendEmail() {
      this.emialConfirmLoading = true;
      try {
        await sendApprovalEmail({
          planCode: this.editRecord.planCode,
          planName: this.editRecord.planName,
          recipients: this.remindEmailUsers,
          reason: this.formData.reason,
        });
        this.$message.success("审核邮件发送成功");
        this.showConfirm = true;
        this.auditDisable = true;
        this.emailConfirmVisible = false;
        this.emialConfirmLoading = false;
      } catch {
        this.emialConfirmLoading = false;
      }
      this.emialConfirmLoading = false;
    },

    handelCancelEmailConfirm() {
      this.emailConfirmVisible = false;
      this.emialConfirmLoading = false;
    },

    async onSubmit() {
      const { file, reviewFile, planEditHistory, formData } = this; // showAudit, confirmAudit,
      if (!file && !reviewFile) {
        this.$message.warning("请选择需要上传的文件");
        return;
      }

      if (this.isDraft && this.isDraft === true) {
        console.log(this.isDraft);
      } else {
        console.log(this.isDraft);
        // eslint-disable-next-line no-lonely-if
        if (!formData.reason) {
          this.$message.warning("请输入变更原因");
          return;
        }
      }

      // if (showAudit && !confirmAudit) {
      //     this.$message.warning('请发送邮件审核并勾选确认已通过审核');
      //     return;
      // }
      this.subloading = true;
      await updateTemp({
        planTempCode: this.editRecord.planCode,
        fileUrl: this.reviewFile?.url || this.file.url,
        reason: this.formData.reason,
      });
      this.subloading = false;
      const { id } = this.editRecord;
      // 提交需要清除保存的信息
      if (planEditHistory && planEditHistory[id]) {
        delete planEditHistory[id];
        localStorage.setItem("planEditHistory", JSON.stringify(planEditHistory));
      }
      this.$emit("cancel");
      this.onCancel(true);
    },
    onCancel(isSubmit = false) {
      // 不是提交按钮需要保存填写信息
      if (!isSubmit) {
        const { planEditHistory, file, showAudit, auditDisable, showConfirm, confirmAudit } = this;
        const { id } = this.editRecord;
        if (file) {
          planEditHistory[id] = {
            file: file
              ? {
                  name: file.name,
                  url: file.url,
                }
              : null,
            showAudit,
            auditDisable,
            showConfirm,
            confirmAudit,
            reason: this.formData.reason,
          };
          localStorage.setItem("planEditHistory", JSON.stringify(planEditHistory));
        }
      }
      this.file = null;
      this.reviewFile = null;
      this.visible = false;
      this.showAudit = false;
      this.showConfirm = false;
      this.confirmAudit = false;
      this.auditDisable = false;
      this.spinning = false;
      this.formData.reason = "";
    },

    // 复核文件上传
    async beforeUploadReviewFile(file) {
      this.reviewFile = file;
      await this.validateReviewFile(file);
      return Promise.reject();
    },

    // 校验文件格式
    async validateReviewFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);
      if (!fileTypeLimit.includes(fileType)) {
        this.reviewFile = null;
        this.$message.error("文件格式仅支持xlsx");
        return;
      }
      if (fileSize > fileMaxSize) {
        this.reviewFile = null;
        this.$message.error("文件最大不超过10M");
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("planCode", this.editRecord.planCode);
      formData.append("planMethod", this.editRecord.planMethod);
      this.spinning = true;
      try {
        const res = await planImport(formData);
        this.spinning = false;
        this.reviewFile.url = res.fileUrl;
      } catch (e) {
        this.spinning = false;
        this.reviewFile = null;
      }
    },

    // 移除复核文件
    removeReviewFile() {
      this.reviewFile = null;
    },
  },
};
</script>

<style lang="less" scoped>
.edit-plan-modal {
  /deep/ .ant-drawer-header {
    background: #fff;
    border: none;
  }
  /deep/ .ant-drawer-body {
    padding: 0;
    height: calc(100% - 56px);
    overflow-y: hidden;
    .ant-spin-nested-loading {
      height: calc(100% - 30px);
      .ant-spin-container {
        height: 100%;
      }
    }
  }
  .alert-tip {
    margin: 0 24px;
    background: #fff2e5;
    /deep/ .ant-alert-icon {
      color: #ff7d00;
    }
    /deep/ .ant-alert-message {
      color: #ff7d00;
    }
  }
  .history {
    width: 320px;
    margin-top: 16px;
    overflow-y: auto;
    border-left: 1px solid #d9dbde;
    .list {
      margin-top: 8px;
    }
  }
  .upload {
    overflow-y: auto;
    flex: 1;
    padding-right: 20px;
  }
  .tips {
    margin-top: 8px;
    margin-bottom: 18px;
    color: #808792;
    font-size: 13px;
    line-height: 20px;
  }
  .desc {
    margin-top: -8px;
  }
  .approved {
    color: #52c41a;
    background: #f6ffed;
    border-color: #b7eb8f;
    padding: 5px 10px;
    border-radius: 4px;
    margin-bottom: 12px;
  }
  .not-approved {
    color: #f5222d;
    background: #fff1f0;
    border-color: #ffa39e;
    padding: 5px 10px;
    border-radius: 4px;
    margin-bottom: 12px;
  }
  /deep/ .title-containe {
    margin-left: 8px;
  }
  .margin {
    margin-top: 24px;
  }
  .block {
    margin-bottom: 24px;
    margin-left: 32px;
  }
  .batch-file {
    border-radius: 4px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .batchBtnStyle {
    background: #f2fbf8;
    .icon-xlsx {
      width: 46px;
      height: 46px;
      margin-right: 16px;
    }
    .icon_load {
      width: 24px;
      height: 24px;
    }
  }
  .item-content {
    .uploadBtn {
      width: 160px;
      height: 32px;
      background: #06b880;
      border-radius: 2px;
      .uploadStyle {
        margin-right: 12px;
      }
    }
  }
  .cursor {
    cursor: pointer;
  }
  .confirm {
    display: block;
    margin-top: 12px;
  }
  .drawer-bottom {
    position: absolute;
    bottom: 0;
    height: 56px;
    background: #fff;
    width: 100%;
    z-index: 99;
    padding: 0 24px;
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #ebedf0;
    .submit-btn {
      margin-left: 12px;
    }
  }
  .time-content {
    color: #808792;
    font-size: 14px;
    line-height: 22px;
    p {
      margin-bottom: 8px;
      span {
        color: #000f25;
      }
      .version {
        font-weight: 500;
      }
      .plan-name {
        color: #06b880;
        cursor: pointer;
      }
    }
  }
}
</style>
